<template>
  <div class="layout">
    <div class="stats-site-wrap">
      <!-- ‘문화예술’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘문화관광콘텐츠’ 분야</h2>
        <ul>
          <li>
            <a href="https://data.kcti.re.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">KCTI DATA</span>
                <span class="stats-desc">- 국내외 문화ㆍ관광ㆍ콘텐츠 통계 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://www.culture.go.kr/data/main/main.do" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">문화 공공 데이터 관장</span>
                <span class="stats-desc">- 문화예술, 문화유산, 문화산업 등 통계 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘문화예술’ 분야 -->
      <!-- ‘문화예술’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘문화예술’ 분야</h2>
        <ul>
          <li>
            <a href="https://www.kopis.or.kr/por/main/main.do" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">공연예술통합전산망 공연통계(예술경영지원센터)</span>
                <span class="stats-desc">- 공연정보, 공연 통계 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://www.mcst.go.kr/libsta/main" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">국가도서관통계시스템(국가도서관위원회)</span>
                <span class="stats-desc">- 도서관 기본정보, 소장자료 이용현황 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘문화예술’ 분야 -->

      <!-- ‘콘텐츠’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘콘텐츠’ 분야</h2>
        <ul>
          <li>
            <a href="https://kobis.or.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">영화관입장권통합전산망(영화진흥위원회)</span>
                <span class="stats-desc">- 전국영화권 입장권 발권정보 각종 영화산업 통계 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘콘텐츠’ 분야 -->

      <!-- ‘저작권’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘저작권’ 분야</h2>
        <ul>
          <li>
            <a href="https://www.copyright.or.kr/information-materials/statistics/registration/index.do" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">저작권 통계(한국저작권위원회)</span>
                <span class="stats-desc">- 저작권 등록 현황 저작권 산업 현황 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘저작권’ 분야 -->

      <!-- ‘미디어’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘미디어’ 분야</h2>
        <ul>
          <li>
            <a href="https://pds.mcst.go.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">정기간행물등록관리시스템</span>
                <span class="stats-desc">- 신문, 잡지 등 정기간행물 등록현황 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://www.kpf.or.kr/front/mediaStats/mediaStatsListPage.do" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">언론통계(한국언론진흥재단)</span>
                <span class="stats-desc">- 신문잡지산업, 어린이미디어 등 언론 관련 통계 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘미디어’ 분야 -->

      <!-- ‘관광’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">‘관광’ 분야</h2>
        <ul>
          <li>
            <a href="https://know.tour.go.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">관광지식정보시스템</span>
                <span class="stats-desc">- 관광 관련 통계 자원 현황 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://datalab.visitkorea.or.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">한국관광데이터랩(한국관광공사)</span>
                <span class="stats-desc">- 관광통계, 관광빅데이터 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://www.tdss.kr/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">관광개발정보시스템</span>
                <span class="stats-desc">- 관광개발 정보 관광자원통계 등 제공</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘관광’ 분야 -->

      <!-- ‘통계’ 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">국가데이터처 통계포털</h2>
        <ul>
          <li>
            <a href="https://kosis.kr/index/index.do" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">KOSIS 국가통계포털</span>
                <span class="stats-desc">- 국가데이터처가 제공하는 One-Stop 통계 서비스</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // ‘통계’ 분야 -->

      <!-- 국제통계 분야 -->
      <div class="stats-site-sec-new">
        <h2 class="tit">국제통계</h2>
        <ul>
          <li>
            <a href="https://uis.unesco.org/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">유네스코(UNESCO) 통계연구소</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://ec.europa.eu/eurostat/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">유럽연합(EU) 통계국</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://www.unwto.org/tourism-statistics/tourism-statistics-database" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">세계관광기구(UNWTO) 통계</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://data.un.org/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">국제연합(UN) 통계</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
          <li>
            <a href="https://data-explorer.oecd.org/" target="_blank" title="새창으로 열림">
              <div class="stats-name">
                <span class="stats-tit">경제협력개발기구(OECD) 통계</span>
              </div>
              <div class="stats-btn-box"><span class="hidden">바로가기</span></div>
            </a>
          </li>
        </ul>
      </div>
      <!-- // 국제통계 분야 -->

    </div>
  </div>
</template>

<script>
import * as api from '@/api/Notice.js'
import StatsSiteListItem from '@/components/StatsSiteListItem'
import BoardPagination from '@/components/BoardPagination'

export default {
  name: 'StatsSite',

  components: {
    StatsSiteListItem,
    BoardPagination
  },

  data () {
    return {
      boardType: '000348',
      searchText: '',
      orderByType: 'D',
      listData: [],
      total: 0,
      page: 1,
      limit: 5,
      block: 10,
      startIdx: 1,
      endIdx: 10
    }
  },

  created () {
    this.initBoard()
  },

  mounted () {
    if (window.innerWidth <= 768) {
      this.block = 5
    }
  },

  methods: {
    initBoard () {
      if (this.$route.query.page) {
        this.page = this.$route.query.page
      }

      if (this.$route.query.searchText) {
        this.searchText = this.$route.query.searchText
      }

      if (this.$route.query.orderByType) {
        this.orderByType = this.$route.query.orderByType
      }

      this.searchBoardTotalList(this.page)
    },

    // 게시판 상세보기 화면 이동
    showDetailView (boardId, boardType, orderRowNum) {
      const paramData = {
        boardId: boardId,
        boardType: boardType,
        target: '국내외 문화 통계 사이트',
        page: this.page + '',
        searchText: this.searchText,
        orderRowNum: orderRowNum
      }

      this.$router.push({ name: '국내외 문화 통계 사이트 상세', query: paramData })
    },

    // 게시판 전체 목록
    async searchBoardTotalList (currentPage) {
      this.startIdx = ((currentPage - 1) * this.limit) + 1
      this.endIdx = currentPage * this.limit
      this.page = currentPage

      const paramData = {
        boardType: this.boardType,
        searchText: this.searchText,
        orderByType: this.orderByType,
        startPage: this.startIdx,
        endPage: this.endIdx
      }

      const boardData = await api.searchBoardList(paramData)
      this.listData = boardData.data

      const totalCnt = await api.boardCnt(paramData)
      this.total = totalCnt.cnt
      this.pageDataSetting(currentPage)
    },

    pagingMethod (page) {
      this.$router.replace({
        name: '국내외 문화 통계 사이트',
        query: {
          page: page,
          searchText: this.searchText,
          orderByType: this.orderByType
        }
      }).catch(() => {})
    },

    pageDataSetting (currentPage) {
      const totalPage = Math.ceil(this.total / this.limit)
      const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
      const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

      const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
      const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
      const list = []
      for (let index = startIndex; index <= endIndex; index++) {
        list.push(index)
      }
      return { first, end, list, currentPage, totalPage }
    }
  },

  watch: {
    $route (to, from) {
      if (to.path == from.path) {
        this.initBoard()
      }
    }
  }
}
</script>

<style scoped>

</style>
